/* eslint-disable react/jsx-filename-extension, import/no-dynamic-require, global-require */
import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./components/App";
import configureStore from "./utils/configureStore";
import { Theme } from "@ebscois/react-component-library";
import "@ebscois/react-component-library/lib/index.css";

function render() {
  // Uncomment this when you are done developing your app..
  // import registerServiceWorker from "./registerServiceWorker";

  // Get initial state from server-side rendering
  // eslint-disable-next-line no-underscore-dangle, no-undef
  const initialState = window.__INITIAL_STATE__;
  const store = configureStore(initialState);

  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <Theme>
          <App />
        </Theme>
      </BrowserRouter>
    </Provider>,
    // eslint-disable-next-line no-undef
    document.getElementById("root"),
  );
  // Uncomment this when you are done developing your app..
  // registerServiceWorker();
}

render();
